module.exports = __webpack_public_path__ + "img/rt.-rev.-richard-allen.1cf62c38.png";